import { bugsnagApiKey } from './environment.bugsnagApiKey';


export const environment = {
    name: 'dev',
    apiUrl: 'https://menu-api.cfamenudev.cfadevelop.com',
    lambdaGatewayUrl: 'https://o4o69avk17.execute-api.us-east-1.amazonaws.com',
    menuGatewayUrl: 'https://menu-gateway.cfamenudev.cfadevelop.com',
    backgroundColor: 'skyblue',
    oktaDetails: {
        appName: 'Chick-fil-A',
        clientId: '0oaic9fbi72PKJn0U0h7',
        idmUrl: 'https://auth.idm-dev.cfadevelop.com/oauth2/token',
        oktaIssuerUrl: 'https://cfahome.oktapreview.com/oauth2/ausc6e4sj2fnPnQ670h7',
        oktaUrl: 'https://cfahome.oktapreview.com',
        redirectUrl: 'https://menu.cfamenudev.cfadevelop.com/login/callback'
    },
    production: false,
    bugsnagApiKey,
    LDClientId: '6549add4e121d91282562b6e',
};
